import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory, 
} from "../../core";
import { IDashboardSharedViewModel, ecogGroups, KeyedDimension } from "./viewModel";

export { ecogGroups }

/**
 * Maps the raw value to an enum value
 * @param n raw value
 */
export function toEcogGroup(n: number): KeyedDimension {
    switch (n) {
        case 0: return ecogGroups.good;
        case 1: return ecogGroups.good;
        case 2: return ecogGroups.poor;
        case 3: return ecogGroups.poor;
        case 4: return ecogGroups.poor;
        default: return ecogGroups.unknown;
    }
}

/**
 * Sort
 * @param a 
 * @param b 
 */
export const sort = (s: ISourceData, a: string, b: string): number => {
    //Alphabetically by key (name)
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.ecogGroup.name);
